import InputNumber from 'rc-input-number';
import { useDispatch, useSelector } from 'react-redux';
import { OperatorsActions } from '../../store/reducers/operators';
import { OperatorField } from './OperatorField';
import { BUSINESS_MODEL_DROPSHIP } from '../../constants/operators';

import styles from './OperatorCommissionSelector.module.scss';

export function OperatorCommissionSelector() {
  const dispatch = useDispatch();
  const {
    businessModel,
    loading: { supplierRetailer: loading },
    configuration: { commission },
  } = useSelector((state) => state.operators);

  const isDropship = businessModel === BUSINESS_MODEL_DROPSHIP;

  const updateCommission = (commission) => {
    dispatch({ type: OperatorsActions.configuration, payload: { commission } });
  };

  if (isDropship) {
    return (
      <OperatorField
        title="Commission"
        description="Invoiced price will reflect the agreed-upon costs negotiated with the vendor’s team."
      />
    );
  }

  return (
    <OperatorField
      title="Commission"
      description="The commission rate (as a percentage) that the seller will be billed per order, excluding shipping and applied after any discounts."
    >
      <div className={styles.valueContainer}>
        <div className={styles.inputPercentage}>
          <InputNumber
            onChange={updateCommission}
            min={0}
            max={100}
            onBlur={(e) => {
              if (isNaN(e.target.value) || e.target.value === '') {
                updateCommission(0);
              }
            }}
            onFocus={(e) => e.target.select()}
            onClick={(e) => e.target.select()}
            value={commission}
            step={1}
            precision={0}
            disabled={loading}
          />
          <span>%</span>
        </div>
      </div>
    </OperatorField>
  );
}
